import * as S from './style.FinalPTESTYield';

const FinalPTESTYield = () => {
    return (
        <S.Container>

        </S.Container>
    )
}

export default FinalPTESTYield;
